import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Modal } from 'src/app/shared/modals/modal';
import { ModalService } from 'src/app/shared/services/modal.service';
import { GoogleCalendarConnectionModalComponent } from './google-calendar-connection-modal/google-calendar-connection-modal.component';
import { ModalHeaderComponent } from 'src/app/shared/modals/components/modal-header/modal-header.component';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { SelectItem } from 'primeng/api';
import { FormsModule } from '@angular/forms';
import { GoogleCalendarIconComponent } from '../google-calendar-icon/google-calendar-icon.component';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { DividerModule } from 'primeng/divider';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { take } from 'rxjs';
import { ApisService } from 'src/app/shared/services/entities/apis/apis.service';
import { SelectedOrgService } from 'src/app/shared/services/selected-org.service';
import { ICalendar } from 'src/app/shared/models/calendars/calendar.model';

@Component({
  selector: 'app-google-calendar-picker-modal',
  standalone: true,
  imports: [
    ModalHeaderComponent, ButtonModule, TranslateModule, DropdownModule, FormsModule,
    GoogleCalendarIconComponent, InputGroupModule, InputGroupAddonModule, DividerModule,
    NgbTooltipModule
  ],
  templateUrl: './google-calendar-picker-modal.component.html',
  styleUrl: './google-calendar-picker-modal.component.scss'
})
export class GoogleCalendarPickerModalComponent extends Modal implements OnInit {

  selectedConnectionId: number | null = null;
  selectedConnection: SelectItem | null = null;
  selectedCalendarId: string | null = null;
  selectedCalendar: SelectItem | null = null;

  connectionOptions: SelectItem[] = [];
  calendarsOptions: SelectItem[] = [];

  fetchingConnections = false;
  fetchingCalendars = false;
  connectingCalendar = false;

  @Input() locationId?: number;
  @Input() lecturerUserId?: number;

  @Output() result = new EventEmitter<ICalendar>();

  constructor(
    private modalService: ModalService,
    private apiService: ApisService,
    private selectedOrgService: SelectedOrgService
  ) {
    super();
  }

  override ngOnInit(): void {
    this.fetchConnections();
  }

  private fetchConnections() {
    const orgId = this.selectedOrgService.getCurrentValue();
    if (!orgId) {
      console.error('Missing orgId!');
      return;
    }

    this.fetchingConnections = true;
    this.apiService.getGoogleCalendarConnections({
      orgId
    }).pipe(take(1)).subscribe({
      next: (connections) => {
        this.connectionOptions = connections.map((connection) => ({
          title: connection.content.connectionTitle,
          label: connection.content.connectionOwnerEmail,
          value: connection.id
        }));
        this.fetchingConnections = false;
      },
      error: (error) => {
        this.fetchingConnections = false;
      }
    });
  }

  onAddConnection() {
    this.modalService.openGoogleCalendarConnectionModal(GoogleCalendarConnectionModalComponent).pipe(take(1)).subscribe(() => {
      this.fetchConnections();
    });
  }

  onCalendarSelect(event: DropdownChangeEvent) {
    this.selectedCalendar = this.calendarsOptions.find((option) => option.value === event.value) || null;
  }

  onConnectionSelect(event: DropdownChangeEvent) {
    this.selectedCalendarId = null;
    this.fetchingCalendars = true;
    this.selectedConnection = this.connectionOptions.find((option) => option.value === event.value) || null;

    this.apiService.getGoogleConnectionCalendars({
      connectionId: event.value
    }).pipe(take(1)).subscribe({
      next: (res) => {
        this.calendarsOptions = res.map((calendar) => ({
          title: calendar.title,
          label: calendar.ownerEmail,
          value: calendar.externalId
        }));
        this.fetchingCalendars = false;
      },
      error: () => {
        this.fetchingCalendars = false;
      }
    });
  }

  onSubmit() {
    if (!this.selectedCalendarId || !this.selectedConnectionId) {
      console.error('invalid');
      return;
    }

    this.connectingCalendar = true;
    this.apiService.connectGoogleCalendar({
      calendarId: this.selectedCalendarId,
      connectionId: this.selectedConnectionId,
      lecturerUserId: this.lecturerUserId,
      locationId: this.locationId
    }).pipe(take(1)).subscribe({
      next: (res) => {
        this.connectingCalendar = false;
        this.result.emit(res);
        this.close();
      },
      error: () => {
        this.connectingCalendar = false;
      }
    });
  }
}
